
import React, { useEffect, useState, useMemo, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/rackMap.css';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Header } from '../components/header/header';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import CardRackInfos from '../components/CardRackInfos/CardRackInfos';
import axiosInstance from '../auth/axiosInstance';
import ModalSucesso from '../components/ModalSucesso';
import Chevron from '../img/chevron.svg';
import ModalSuccessFail from '../components/ModalConfirm/ModalConfirm';
import chevronDuplo from '../img/chevronDuplo.svg';
import saveIcon from '../img/save.svg';
import downloadBtn from '../img/donwloadbtn.svg';
import { NavigateWayContext } from '../store/NavigateWayContext';
import ExportToPDF from '../utils/ExportToPDF';
import concatBipartidos from '../utils/concatBipartidos';
import BoardCell from '../components/BoardCell/BoardCell';
import Piece from '../components/Piece/Piece';
import { use } from 'react';

import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


function DataHall({ type }) {
    const location = useLocation()
    const param = location.state
    const navigate = useNavigate()
    const { navigateWay } = useContext(NavigateWayContext);
    const [board, setBoard] = useState([]);

    // verifica se já existe mapa salvo no banco para, no salvamento, enviar POST ou PUT
    const [newRoom, setNewRoom] = useState(false);
    const [roomDetail, setRoomDetail] = useState([]);
    const [racksArr, setRacksArr] = useState([]);
    
    const [showCardRackInfo, setShowCardRackInfo] = useState(false)
    const [rackSelected, setRackSelected] = useState({})

    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [confirmRemovalType, setConfirmRemovalType] = useState(null); // 'row' or 'column'
    const [indexToRemove, setIndexToRemove] = useState(null);

    const [showModalCleanMap, setShowModalCleanMap] = useState(false);

    const [openModaConfirm, setOpenModaConfirm] = React.useState(false);
    const [status, setStatus] = React.useState(false);
    const [content, setContent] = React.useState("");
    const [typeModal, setTypeModal] = React.useState(false)
    const [placedRackIds, setPlacedRackIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [closeSideBar, setCloseSideBar] = useState(false);

    const [activeContextMenu, setActiveContextMenu] = useState(null);

    const [showPDF, setShowPDF] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfFileName, setPdfFileName] = useState('fileName');

    const [autoSaveStart, setAutoSaveStart] = useState(false);

    async function getFloorPlan() {
      try {
        // Faz a requisição sem responseType: 'arraybuffer'
        const response = await axiosInstance.get(`room-map/floor-plan/${param.roomId}`);
        setPdfFileName(response.data.filename);
    
        // Converte o Base64 para um Blob
        const byteCharacters = atob(response.data.file); // Decodifica o Base64
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' }); // Cria o Blob
    
        // Cria uma URL temporária para o Blob
        const url = URL.createObjectURL(blob);
        setPdfUrl(url); // Define a URL do PDF no estado
      } catch (error) {
        console.error('Ther is no Floor Plan saved here yet!');
      }
    }

    async function saveFloorPlan() {
      try {
        const fileInput = document.getElementById('file');
        const file = fileInput.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('roomId', param.roomId);
    
        await axiosInstance.post(`room-map/floor-plan/${roomDetail.site_id}/${param.roomId}/${roomDetail.room}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => {
          getFloorPlan();
          handleRemoveFile();
        });        
      } catch (error) {
        console.error('Erro ao enviar o PDF:', error);
      }
    }


    // CONTROLA A VISUALIZAÇÃO DO MAPA
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWidth(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    async function dynamicReduce(data) {
        const res = {};
        for (const objeto of data) {
            const area = objeto['fileira'];
            if (!res[area]) {
                res[area] = [];
            }
            res[area].push(objeto);
            // Ordena os itens na lista pela 'posicao', pra garantir que a montagem esteja na ordem correta
            res[area].sort((a, b) => a.posicao - b.posicao);
        }
        return res;
    }

    async function getRacks() {
        const roomInfo = param.roomInfo
        let rowInfo = await dynamicReduce(param.roomData)
        rowInfo = await concatBipartidos(rowInfo) 
        setRoomDetail(roomInfo)
        setRacksArr(rowInfo)
    }


    useEffect(() => {
        getRacks()
        getFloorPlan()
    }, [])

    const getPlacedRackIdsFromBoard = (board) => {
      const rackIds = [];
      board.forEach((cell) => {
        if (cell.content && cell.content.type === 'rack') {
          rackIds.push(cell.content.cellInfo.id);
        }
      });
      return rackIds;
    };

    async function getRoomMap() {
      let boardData = {};
        try {
            const res = await axiosInstance.get(`room-map/room-map-by-id/${param.roomInfo.id}`);  
                
            if (res.data && res.data[0].cells.length >= 1) {
              setNewRoom(false)
              boardData = res.data[0];
            } else { 
              setNewRoom(true)
              boardData = {
                  numRows: 10,
                  numCols: 10,
                  cells: [],
              };
            }
    
            // Constrói o novo tabuleiro e atualiza o estado
            const newBoard = buildBoard(boardData.numRows, boardData.numCols, boardData.cells);
            setBoard(newBoard);

            const initialPlacedRackIds = getPlacedRackIdsFromBoard(newBoard);
            setPlacedRackIds(initialPlacedRackIds);
        } catch (error) {
            console.error('There is no map in this room yet!');

            setNewRoom(true)
            boardData = {
                numRows: 10,
                numCols: 10,
                cells: [],
            };

            // Constrói o novo tabuleiro e atualiza o estado
            const newBoard = buildBoard(boardData.numRows, boardData.numCols, boardData.cells);
            setBoard(newBoard);

            const initialPlacedRackIds = getPlacedRackIdsFromBoard(newBoard);
            setPlacedRackIds(initialPlacedRackIds);
        }
    }    

    useEffect(() => {
        getRoomMap()
    }, []);

    // Função para construir o tabuleiro
    const buildBoard = (numRows, numCols, cells = []) => {
        const board = [];

        for (let row = 0; row < numRows; row++) {
            for (let col = 0; col < numCols; col++) {
                const existingCell = cells.find((c) => c.row === row && c.col === col);
                board.push({
                row,
                col,
                content: existingCell ? existingCell.content : null,
                });
            }
        }

        return board;
    };

    const handleDropPiece = (row, col, piece) => {
      setBoard((prevBoard) => {
        if (!canPlacePiece(prevBoard, row, col)) {
          return prevBoard; // return previous board to prevent changes
        }

        // Verificar se o piece.type corresponde a um dos tipos mencionados e limpa a label
        const typesToClearLabel = ["fancoil", "equipment", "rack-mda", "sdu", "empty-floor"];
        if (typesToClearLabel.includes(piece.type)) {
          piece.cellInfo.label = "";
        }

        const newBoard = prevBoard.map((cell) => {
          if (cell.row === row && cell.col === col) {
            return { ...cell, content: piece };
          }
          return cell;
        });
    
        if (piece.type === 'rack') {
          setPlacedRackIds((prevIds) => [...prevIds, piece.cellInfo.id]);
        }
    
        return newBoard;
      });
    };
    
    const canPlacePiece = (board, row, col) => {
      const cell = board.find((cell) => cell.row === row && cell.col === col);
      if (cell && !cell.content) {
        return true;
      }
      return false;
    };

    const handleDeletePiece = (row, col) => {
      setBoard((prevBoard) => {
        const cell = prevBoard.find((c) => c.row === row && c.col === col);
        let rackIdToRemove = null;
    
        if (cell && cell.content && cell.content.type === 'rack') {
          rackIdToRemove = cell.content.cellInfo.id;
        }
    
        const newBoard = prevBoard.map((cell) => {
          if (cell.row === row && cell.col === col) {
            return { ...cell, content: null };
          }
          return cell;
        });
    
        if (rackIdToRemove !== null) {
          setPlacedRackIds((prevIds) => prevIds.filter((id) => id !== rackIdToRemove));
        }
    
        return newBoard;
      });
    }; 

    const availableRacks = useMemo(() => {
      const racks = {};
      Object.keys(racksArr).forEach((fileira) => {
        // Filtra os racks que não estão colocados
        let racksInFileira = racksArr[fileira].filter((item) => !placedRackIds.includes(item.id));
    
        // Se houver um termo de busca, filtre os racks com base nele
        if (searchTerm.trim() !== '') {
          const lowerCaseSearchTerm = searchTerm.toLowerCase();
          racksInFileira = racksInFileira.filter((item) =>
            item.nscala.toLowerCase().includes(lowerCaseSearchTerm)
          );
        }
    
        if (racksInFileira.length > 0) {
          racks[fileira] = racksInFileira;
        }
      });
      return racks;
    }, [racksArr, placedRackIds, searchTerm]);
    

    // Função para adicionar uma linha
    const addRow = () => {
        setBoard((prevBoard) => {
        const numRows = Math.max(...prevBoard.map((cell) => cell.row)) + 1;
        const numCols = Math.max(...prevBoard.map((cell) => cell.col)) + 1;
        const newRowCells = [];
        for (let col = 0; col < numCols; col++) {
            newRowCells.push({ row: numRows, col, content: null });
        }
        return [...prevBoard, ...newRowCells];
        });
    };

    const removeRow = () => {
      const numRows = Math.max(...board.map((cell) => cell.row)) + 1;
      if (numRows <= 1) return;
    
      const rowToRemove = numRows - 1;
    
      // Check if there are any elements in the row to remove
      const hasElements = board.some(
        (cell) => cell.row === rowToRemove && cell.content !== null
      );
    
      if (hasElements) {
        // Open confirmation modal
        setIsConfirmModalOpen(true);
        setConfirmRemovalType('row');
        setIndexToRemove(rowToRemove);
      } else {
        // Proceed to remove the row
        proceedToRemoveRow(rowToRemove);
      }
    };
    

    // Função para adicionar uma coluna
    const addColumn = () => {
        setBoard((prevBoard) => {
        const numRows = Math.max(...prevBoard.map((cell) => cell.row)) + 1;
        const numCols = Math.max(...prevBoard.map((cell) => cell.col)) + 1;
        const newBoard = [...prevBoard];
        for (let row = 0; row < numRows; row++) {
            newBoard.push({ row, col: numCols, content: null });
        }
        return newBoard;
        });
    };

    const removeColumn = () => {
      const numCols = Math.max(...board.map((cell) => cell.col)) + 1;
      if (numCols <= 1) return;
    
      const colToRemove = numCols - 1;
    
      // Check if there are any elements in the column to remove
      const hasElements = board.some(
        (cell) => cell.col === colToRemove && cell.content !== null
      );
    
      if (hasElements) {
        // Open confirmation modal
        setIsConfirmModalOpen(true);
        setConfirmRemovalType('column');
        setIndexToRemove(colToRemove);
      } else {
        // Proceed to remove the column
        proceedToRemoveColumn(colToRemove);
      }
    };


    const proceedToRemoveRow = (rowToRemove) => {
      // Find racks in the row to be removed
      const racksInRow = board
        .filter(
          (cell) =>
            cell.row === rowToRemove &&
            cell.content &&
            cell.content.type === 'rack'
        )
        .map((cell) => cell.content.cellInfo.id);
    
      // Update the board by removing the row
      const newBoard = board.filter((cell) => cell.row < rowToRemove);
      setBoard(newBoard);
    
      // Update placedRackIds to remove racks from the removed row
      setPlacedRackIds((prevIds) =>
        prevIds.filter((id) => !racksInRow.includes(id))
      );
    };
    
    const proceedToRemoveColumn = (colToRemove) => {
      // Find racks in the column to be removed
      const racksInCol = board
        .filter(
          (cell) =>
            cell.col === colToRemove &&
            cell.content &&
            cell.content.type === 'rack'
        )
        .map((cell) => cell.content.cellInfo.id);
    
      // Update the board by removing the column
      const newBoard = board.filter((cell) => cell.col < colToRemove);
      setBoard(newBoard);
    
      // Update placedRackIds to remove racks from the removed column
      setPlacedRackIds((prevIds) =>
        prevIds.filter((id) => !racksInCol.includes(id))
      );
    };
    

    // Função para adicionar uma coluna
    const cleanMap = () => {      
      // Limpar o conteúdo do tabuleiro, ou seja, todos os elementos.
      setBoard((prevBoard) => {
          return prevBoard.map((cell) => ({
              ...cell,
              content: null, // Define que a célula não tem conteúdo
          }));
      });
  
      // Resetar o estado de racks colocados
      // Garante que todos os racks disponíveis sejam visíveis na sidebar novamente
      setPlacedRackIds([]);
      setShowModalCleanMap(false);
    };


    // // WARNING!!!  -  DESCOMENTAR PARA ATIVAR AUTOSAVE A CADA 10 SEGUNDOS  -  WARNING!!! BUG AQUI PODE EXCLUIR O MAPA INDEFINIDAMENTE
    // useEffect(() => {
    //   setTimeout(() => {
    //     if(board.length > 100) {
    //       console.log('Auto save started!');
    //       console.log('Board: ', board.length);
    //     autoSaveBoard();
    //     }
        
    //   }, 10000);
    // });

    // const autoSaveBoard = async () => {
    //   const numRows = Math.max(...board.map((cell) => cell.row)) + 1;
    //   const numCols = Math.max(...board.map((cell) => cell.col)) + 1;

    //   const boardData = {
    //       site_id: roomDetail.site_id,
    //       roomId: roomDetail.id,
    //       room: roomDetail.room,
    //       numRows,
    //       numCols,
    //       cells: board.map((cell) => ({
    //           row: cell.row,
    //           col: cell.col,
    //           content: cell.content
    //           ? {
    //               size: cell.content.size,
    //               type: cell.content.type,
    //               width: cell.content.width,
    //               height: cell.content.height,
    //               color: cell.content.color,
    //               cellInfo: cell.content.cellInfo,
    //               }
    //           : null,
    //       })),
    //   };

    //   if(newRoom){
    //       await axiosInstance.post("room-map", boardData)
    //         .catch((err) => {
    //           console.log(err);
    //           setOpenModaConfirm(true);
    //           setContent("Error on room map saving!");
    //           setStatus(true);
    //           setTypeModal(false);
    //       });

    //   } else {
    //       await axiosInstance.put(`room-map/${param.roomInfo.id}`, boardData)
    //         .catch((err) => {
    //           console.log(err);
    //           setOpenModaConfirm(true);
    //           setContent("Error on room map updating!");
    //           setStatus(true);
    //           setTypeModal(false);
    //       });
    //   }        
    // };

    const saveBoard = async () => {
        const numRows = Math.max(...board.map((cell) => cell.row)) + 1;
        const numCols = Math.max(...board.map((cell) => cell.col)) + 1;

        const boardData = {
            site_id: roomDetail.site_id,
            roomId: roomDetail.id,
            room: roomDetail.room,
            numRows,
            numCols,
            cells: board.map((cell) => ({
                row: cell.row,
                col: cell.col,
                content: cell.content
                ? {
                    size: cell.content.size,
                    type: cell.content.type,
                    width: cell.content.width,
                    height: cell.content.height,
                    color: cell.content.color,
                    cellInfo: cell.content.cellInfo,
                    }
                : null,
            })),
        };

        if(newRoom){
            await axiosInstance.post("room-map", boardData)
            .then((res) => {
                setOpenModaConfirm(true);
                setContent("Room map saved successfully!");
                setStatus(true);
                setTypeModal(true);
            })
            .catch((err) => {
                console.log(err);
                setOpenModaConfirm(true);
                setContent("Error on room map saving!");
                setStatus(true);
                setTypeModal(false);
            });

        } else {
            await axiosInstance.put(`room-map/${param.roomInfo.id}`, boardData)
            .then((res) => {
                setOpenModaConfirm(true);
                setContent("Room map updated successfully!");
                setStatus(true);
                setTypeModal(true);
            })
            .catch((err) => {
                console.log(err);
                setOpenModaConfirm(true);
                setContent("Error on room map updating!");
                setStatus(true);
                setTypeModal(false);
            });
        }        
    };

    const handleOpenContextMenu = (row, col) => {
      setActiveContextMenu({ row, col });
    };
    
    const handleCloseContextMenu = () => {
      setActiveContextMenu(null);
    };

    const [rowLength, setRowLength] = useState(0);
    const [colLength, setColLength] = useState(0);

    useEffect(() => {
      if (board.length > 0) { // Only calculate if the board exists
        const numRows = Math.max(...board.map((cell) => cell.row)) + 1;
        const numCols = Math.max(...board.map((cell) => cell.col)) + 1;
        setRowLength(numRows);
        setColLength(numCols);
      }
    }, [board]);

    const renderBoard = () => {
      const numRows = Math.max(...board.map((cell) => cell.row)) + 1;
      const numCols = Math.max(...board.map((cell) => cell.col)) + 1;
  
      const rows = Array.from({ length: numRows + 1 }, () => Array(numCols + 1).fill(null));
  
      // Create column headers (numbers)
      const colHeaders = Array.from({ length: numCols }, (_, i) => i + 1); // 1, 2, 3...
      rows[0] = [null, ...colHeaders];
  
      // Create row headers (numbers) and populate the board
      for (let i = 1; i <= numRows; i++) {
          rows[i][0] = i;
          for (let j = 1; j <= numCols; j++) {
              const cell = board.find(c => c.row === i - 1 && c.col === j - 1);
              rows[i][j] = cell ? cell : null;
          }
      }
  
      return (
          <div>
              {rows.map((rowCells, rowIndex) => (
                  <div key={rowIndex} className="board-row">
                      {rowCells.map((cell, colIndex) => {
                          if (rowIndex === 0 && colIndex === 0) {
                              return <div key={`${rowIndex}-${colIndex}`} className="board-cell header corner"></div>;
                          } else if (rowIndex === 0) {
                              return <div key={`${rowIndex}-${colIndex}`} className="board-cell header">{cell}</div>; // Column header (number)
                          } else if (colIndex === 0) {
                              return <div key={`${rowIndex}-${colIndex}`} className="board-cell header">{cell}</div>; // Row header (number)
                          } else {
                              return (
                                  <BoardCell
                                      type={type}
                                      key={`${rowIndex - 1}-${colIndex - 1}`}
                                      row={rowIndex - 1}
                                      col={colIndex - 1}
                                      cell={cell}
                                      onDropPiece={handleDropPiece}
                                      onDeletePiece={handleDeletePiece}
                                      onCellClick={handleCellClick}
                                      onEditLabel={handleEditLabel}
                                      activeContextMenu={activeContextMenu}
                                      onOpenContextMenu={handleOpenContextMenu}
                                      onCloseContextMenu={handleCloseContextMenu}
                                  />
                              );
                          }
                      })}
                  </div>
              ))}
          </div>
      );
    };

    const handlePieceClick = (cellInfo) => {
      const rackId = cellInfo.id;
      let rackData = null;
      for (const fileira in racksArr) {
        const racksInFileira = racksArr[fileira];
        const rack = racksInFileira.find((r) => r.id === rackId);
        if (rack) {
          rackData = rack;
          break;
        }
      }
      if (rackData) {
        setRackSelected(rackData.rackSelected);
        setShowCardRackInfo(true);
      }
    };

    const handleCellClick = (cell) => {
      if (cell && cell.content && cell.content.type === "rack") {
        const rackId = cell.content.cellInfo.id;
        let rackData = null;
        for (const fileira in racksArr) {
          const racksInFileira = racksArr[fileira];
          const rack = racksInFileira.find((r) => r.id === rackId);
          if (rack) {
            rackData = rack;
            break;
          }
        }
        if (rackData) {
          setRackSelected(rackData.rackSelected);
          setShowCardRackInfo(true);
        }
      }
    };

    const [accordionState, setAccordionState] = useState({
      'Racks': false,
      'Hallway Type': false,
      'Refrigeration Equipment': false,
      'Electrical Equipment': false,
      'Doors': false,
      'Other': false,
    });
    
    const toggleAccordion = (section) => {
      setAccordionState((prevState) => {
        const isCurrentlyOpen = prevState[section];
        const newState = {};
    
        Object.keys(prevState).forEach((key) => {
          if (key === section) {
            newState[key] = !isCurrentlyOpen; // Alterna o estado da seção clicada
          } else {
            newState[key] = false; // Fecha todas as outras seções
          }
        });
    
        return newState;
      });
    };

    const handleEditLabel = (row, col, newLabel) => {
      setBoard((prevBoard) =>
        prevBoard.map((cell) =>
          cell.row === row && cell.col === col
            ? { ...cell, content: { ...cell.content, cellInfo: { ...cell.content.cellInfo, label: newLabel } } }
            : cell
        )
      );
    };

    useEffect(() => {
    }, [closeSideBar])


    const [updateFile, setUpdateFile] = useState(false);
    const [fileName, setFileName] = useState('Add file here');
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        setFileName(file.name);
      } else {
        setFileName('Add file here');
      }
    };
  
    const handleRemoveFile = () => {
      setFileName('Add file here'); // Reseta o nome do arquivo
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Limpa o valor do input de arquivo
      }
    };


    return (
        <section className='map-body'>
            <Header line>
                <Breadcrumb
                    site={true}
                    room={true}
                    map={false}
                    newcount={false}
                    diagram={true}
                />
            </Header>
            <DndProvider backend={HTML5Backend}>
                <div className="body-container">
                  {
                    type == "View Only" ?
                    <></> :
                    <div className="sidebar" style={closeSideBar ? { width: "80px" } : { width: "540px"}}>
                      <div className="sidebar-header">
                        {
                          closeSideBar ?
                          <></> :
                          <h2>Map Configurations</h2>
                        }
                        <img 
                          src={chevronDuplo} 
                          onClick={() => setCloseSideBar(!closeSideBar)}
                          style={closeSideBar ? {transform: "rotate(0deg)"} : {transform: "rotate(180deg)"}}
                          alt="Chevron to minimize the sidebar" />
                      </div>

                      {/* switch para alternar entre mapa e planta baixa */}
                      { 
                        closeSideBar ?
                        <></>:
                        <div className="sidebar-header-switch">
                          <button onClick={() => setShowPDF(false)} style={!showPDF ? {backgroundColor:'#04a0ab', color:'#fff'} : {backgroundColor:'#e9e9e9', color:'#0008'}}>Room Map</button>
                          <button onClick={() => setShowPDF(true)} style={showPDF ? {backgroundColor:'#04a0ab', color:'#fff'} : {backgroundColor:'#e9e9e9', color:'#0008'}}>Floor Plan</button>
                        </div>
                      }

                      {/* contador de linhas e colunas do mapa */}
                      {
                        closeSideBar || showPDF ?
                        <></> :
                        <div className="sidebar-header">
                          <p>
                            Lines
                            <span style={{fontWeight: "bold", margin:"0 10px"}}>{rowLength}</span>
                            x
                            <span style={{fontWeight: "bold", margin:"0 10px"}}>{colLength}</span>
                            Columns
                          </p>
                        </div>
                      }
                      
                      {
                        closeSideBar || showPDF ?
                        <></> :
                        <div className="controls-opened">
                            <div className="controls-opened-add-container">
                              <div className="controls-opened-add">
                                <button onClick={addRow}>Add Line</button>
                                <button onClick={removeRow}>Remove Line</button>
                              </div>
                              <div className="controls-opened-add">
                                <button onClick={addColumn}>Add Column</button>
                                <button onClick={removeColumn}>Remove Column</button>
                              </div>
                            </div>


                            <div className="controls-opened-save">
                              <button onClick={() => setShowModalCleanMap(true)} className="save-button">Clean Map</button>
                              <button onClick={saveBoard} className="save-button">
                                <img src={saveIcon} alt="icon to save the map while the sidebar closed" />
                                Save Map
                              </button>
                            </div>
                        </div>
                      }

                      {/* COMPONENTES NO MENU DO PDF --- */}
                      {
                        showPDF && !closeSideBar ?
                        <div className="controls-opened-pdf">
                          {
                            <button onClick={() => setUpdateFile(!updateFile)}>
                              { 
                                pdfUrl ? 
                                  updateFile ? 'Close' : 'Update Floor Plan' : updateFile ? 'Close' : 'Add Floor Plan'}
                            </button>
                          }
                          {
                            updateFile ?
                            <div className='container-input-file'>
                              <p>{pdfUrl ? 'Update PDF file of floor plain' : 'Add PDF file of floor plain'}</p>
                              <input
                                type="file"
                                id="file"
                                accept=".pdf"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                                ref={fileInputRef}
                              />
                              <label
                                htmlFor="file"
                                style={{
                                  width:"100%",
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  padding: '10px 20px',
                                  boxSizing: 'border-box',
                                  border: '2px dashed #ccc',
                                  borderRadius: '5px',
                                  cursor: 'pointer',
                                  backgroundColor: '#f9f9f9',
                                  color: '#333',
                                  fontSize: '16px',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                }}
                              >
                                {fileName}
                                {fileName !== 'Add file here' && (
                                  <span
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleRemoveFile();
                                    }}
                                    style={{
                                      marginLeft: '10px',
                                      color: '#ff0000',
                                      cursor: 'pointer',
                                      fontSize: '20px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    x
                                  </span>
                                )}
                              </label>
                              <button onClick={() => (setUpdateFile(!updateFile), saveFloorPlan())} className="save-button"> Enviar </button>
                            </div>

                            : <>{pdfFileName ? pdfFileName : ''}</>
                          }
                        </div>
                        :<></>
                      }

                      {/* COMPONENTES NO MENU DO MAPA --- */}
                      {
                        closeSideBar || showPDF ?
                          <div className="controls-closed" onClick={saveBoard} style={showPDF ? {display: "none"} : {display: "flex"}}>
                            <img src={saveIcon} alt="icon to save the map while the sidebar closed" />
                          </div>
                        :
                        <div className="sidebar-components">
                          {/* Accordion para RACKS */}
                          <div className="accordion-section">
                              <h4 onClick={() => toggleAccordion('Racks')}>
                                Racks
                                <img
                                  src={Chevron}
                                  alt="Toggle"
                                  style={{
                                    transform: accordionState['Racks'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.2s',
                                  }}
                                />
                              </h4>
                              {accordionState['Racks'] && (
                                <div className="accordion-section-options">
                                  {/* Barra de Busca */}
                                  <div className="accordion-section-search">
                                    <input 
                                      type="text"
                                      placeholder='Search for rack name'
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                  </div>
                                  {/* Lista Filtrada de Racks */}
                                  {Object.keys(availableRacks).map((fileira) => (
                                    <div key={fileira} className='racks-list-category'>
                                      <h5>Row {fileira}</h5>
                                      <div className='sidebar-elements-list'>
                                        {availableRacks[fileira].map((item) => (
                                          <Piece
                                            key={item.id}
                                            size="rack"
                                            type="rack"
                                            cellInfo={{
                                              label: item.nscala,
                                              id: item.id,
                                              status1: item.status,
                                              status2: item.reserved,
                                            }}
                                            onPieceClick={handlePieceClick}
                                          />
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                  {/* Exibir mensagem se nenhum rack corresponder à busca */}
                                  {Object.keys(availableRacks).length === 0 && (
                                    <p style={{color:'red'}}>No rack found!</p>
                                  )}
                                </div>
                              )}
                          </div>


                          {/* Hallway Type */}
                          <div className="accordion-section">
                            <h4 onClick={() => toggleAccordion('Hallway Type')}>
                              Hallway Type
                              <img
                                src={Chevron}
                                alt="Toggle"
                                style={{
                                  transform: accordionState['Hallway Type'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                  transition: 'transform 0.2s',
                                }}
                              />
                            </h4>
                            {accordionState['Hallway Type'] && (
                              <div className='sidebar-elements-list'>
                                <Piece
                                  size="hallway-warm"
                                  type="hallway-warm"
                                  cellInfo={{ label: 'Hallway Warm', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hallway-warm1"
                                  type="hallway-warm1"
                                  cellInfo={{ label: 'Hallway Warm', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hallway-warm2"
                                  type="hallway-warm2"
                                  cellInfo={{ label: 'Hallway Warm', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hallway-warm3"
                                  type="hallway-warm3"
                                  cellInfo={{ label: 'Hallway Warm', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hallway-cold"
                                  type="hallway-cold"
                                  cellInfo={{ label: 'Hallway Cold', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hallway-cold1"
                                  type="hallway-cold1"
                                  cellInfo={{ label: 'Hallway Cold', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hallway-cold2"
                                  type="hallway-cold2"
                                  cellInfo={{ label: 'Hallway Cold', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hallway-cold3"
                                  type="hallway-cold3"
                                  cellInfo={{ label: 'Hallway Cold', id: '', status1: '', status2: '' }}
                                />
                              </div>
                            )}
                          </div>
                          

                          {/* Refrigeration Equipment */}
                          <div className="accordion-section">
                            <h4 onClick={() => toggleAccordion('Refrigeration Equipment')}>
                              Refrigeration Equipment
                              <img
                                src={Chevron}
                                alt="Toggle"
                                style={{
                                  transform: accordionState['Refrigeration Equipment'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                  transition: 'transform 0.2s',
                                }}
                              />
                            </h4>
                            {accordionState['Refrigeration Equipment'] && (
                              <div className='sidebar-elements-list'>
                                <Piece
                                    size="fancoil"
                                    type="fancoil"
                                    cellInfo={{ label: 'Fancoil', id: '', status1: '', status2: '' }}
                                />
                              </div>
                            )}
                          </div>

                          {/* Electrical Equipment */}
                          <div className="accordion-section">
                            <h4 onClick={() => toggleAccordion('Electrical Equipment')}>
                            Electrical Equipment
                              <img
                                src={Chevron}
                                alt="Toggle"
                                style={{
                                  transform: accordionState['Electrical Equipment'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.2s',
                                }}
                              />
                            </h4>
                            {accordionState['Electrical Equipment'] && (
                              <div className='sidebar-elements-list'>
                                <Piece
                                    size="equipment"
                                    type="equipment"
                                    cellInfo={{ label: 'Equipment', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                    size="rack-mda"
                                    type="rack-mda"
                                    cellInfo={{ label: 'Rack MDA', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="sdu"
                                  type="sdu"
                                  cellInfo={{ label: 'SDU', id: '', status1: '', status2: '' }}
                                />
                              </div>
                            )}
                          </div>

                          {/*  Doors */}
                          <div className="accordion-section">
                            <h4 onClick={() => toggleAccordion('Doors')}>
                              Doors
                              <img
                                src={Chevron}
                                alt="Toggle"
                                style={{
                                  transform: accordionState['Doors'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.2s',
                                }}
                              />
                            </h4>
                            {accordionState['Doors'] && (
                              <div className='sidebar-elements-list'>
                                <Piece
                                    size="door-bottom"
                                    type="door-bottom"
                                    cellInfo={{ label: 'Door', id: '', status1: '', status2: '' }}
                                />
                              </div>
                            )}
                          </div>

                          {/* Other */}
                          <div className="accordion-section">
                            <h4 onClick={() => toggleAccordion('Other')}>
                              Other
                              <img
                                src={Chevron}
                                alt="Toggle"
                                style={{
                                  transform: accordionState['Other'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                  transition: 'transform 0.2s',
                                }}
                              />
                            </h4>
                            {accordionState['Other'] && (
                              <div className='sidebar-elements-list'>
                                <Piece
                                  size="extinguisher"
                                  type="extinguisher"
                                  cellInfo={{ label: 'Extinguisher', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="hydrant"
                                  type="hydrant"
                                  cellInfo={{ label: 'Hydrant', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                    size="empty-floor"
                                    type="empty-floor"
                                    cellInfo={{ label: 'Empty Floor', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="floor-glass"
                                  type="floor-glass"
                                  cellInfo={{ label: 'Floor-glass', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="coluna"
                                  type="coluna"
                                  cellInfo={{ label: 'Masonry', id: '', status1: '', status2: '' }}
                                />
                                <Piece
                                  size="mobilia"
                                  type="mobilia"
                                  cellInfo={{ label: 'Furniture', id: '', status1: '', status2: '' }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      }
                    </div>
                  }

                  <div className={showPDF ? "board-pdf" : "board"} id="board-container">
                    {
                      showPDF ?
                        <iframe
                          src={pdfUrl}
                          width="100%"
                          height="100%"
                          title="Floor Plan PDF"
                          style={{ border: 'none' }}
                          onLoad={() => console.log('PDF carregado com sucesso!')}
                          onError={(e) => console.error('Erro ao carregar o PDF:', e)}
                        />
                      :
                        renderBoard()}
                  </div>

                  {
                    showPDF ?
                    <></> :
                    <div className='body-container-btn-export'>
                      <button onClick={() => ExportToPDF(navigateWay)}><img src={downloadBtn} alt="" /></button>
                    </div>
                  }
                  
                  
                    
                </div>
            </DndProvider>

            {
              openModaConfirm && (
                <ModalSucesso
                    status={status}
                    content={content}
                    ok={() => (setStatus(false), setOpenModaConfirm(false))}
                    tipo={typeModal}
                />
              )
            }

            {
              showModalCleanMap && (
                <ModalSuccessFail
                  content={`This action will remove all elements from the map. Do you really want to continue?`}
                  yes={() => cleanMap()}
                  no={() => setShowModalCleanMap(false)}
                />
              )
            }

            {
              isConfirmModalOpen && (
                <ModalSuccessFail
                  content={`In this line ${confirmRemovalType === 'row' ? 'line' : 'column'}, there are elements, remove anyway?`}
                  yes={() => {
                    if (confirmRemovalType === 'row') {
                      proceedToRemoveRow(indexToRemove);
                    } else if (confirmRemovalType === 'column') {
                      proceedToRemoveColumn(indexToRemove);
                    }
                    setIsConfirmModalOpen(false);
                  }}
                  no={() => {
                    setIsConfirmModalOpen(false);
                  }}
                />
              )
            }

            {
              showCardRackInfo && (
                <CardRackInfos
                  close={() => (setShowCardRackInfo(false), setRackSelected(''))}
                  rackSelected={rackSelected}
                />
              )
            }
            
        </section>
    );
}

export default DataHall;
